import React from 'react';
import ReactDOM from 'react-dom';
import './stylesheets/index.css';
import SamTable from './components/Table';
import * as serviceWorker from './serviceWorker';

// The entrypoint to the application
ReactDOM.render(
  <React.StrictMode>
    <SamTable />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
serviceWorker.unregister();
